<template>
  <Modal :modalId="modalId" size="modal-md">
    <ModalHeader :title="$t('xContactYourDealerModalHeader')" icon="far fa-phone mr-1" :style="{ padding: '4px 12px' }">
      <div class="cols-auto">
        <button
          type="button"
          class="btn btn-icon-button btn-icon-button--gray"
          @click="closeModal(modalId)"
          data-test-hook="CloseModalBtn"
        >
          <i class="fas fa-times" />
        </button>
      </div>
    </ModalHeader>
    <ModalBody>
      <div class="my-2">
        <div class="mb-2">
          <strong>{{ $t('xContactYourDealerModalInformation') }}:</strong>
        </div>
        <div class="mb-1">{{ dealerInfo.preferredDealerName }}</div>
        <div class="mb-1">{{ dealerInfo.preferredDealerPhone }}</div>
        <div>{{ dealerInfo.preferredDealerEmail }}</div>
      </div>
    </ModalBody>
    <ModalFooter class="py-1">
      <button
        type="button"
        class="btn btn-secondary text-sm ml-auto"
        @click="closeModal(modalId)"
        data-test-hook="dealerContactDoneBtn"
      >
        {{ $t('xDone') }}
      </button>
    </ModalFooter>
  </Modal>
</template>

<script>
export default {
  props: ['modalId', 'dealerInfo']
}
</script>
